module.exports = __webpack_public_path__ + "static/media/mobix_delivery.9347d0fa.png";